import { Navigate, Route, Routes } from 'react-router-dom';

import { useEnumApi } from 'contexts/EnumApiContext';
import { ROLE } from 'data/data';
import { MenuInfo } from 'data';
import { Error404 } from 'pages';
import AuthorityRoute from 'components/route/AuthorityRoute';
import { MonitoringSettingLayout } from 'layout/monitoring';
import MonitoringSettingTabsRoutes from './MonitoringSettingTabsRoutes';

export default function MonitoringSettingRoutes() {
    const setting = MenuInfo.CMMS_MANAGEMENT;
    const { role } = useEnumApi();
    return (
        <Routes>
            <Route path="/*" element={ <MonitoringSettingLayout/> }>
                <Route path="/*" element={ <Navigate to={setting.children[0].path}/> }/>
                {
                    setting.children.map(child => {
                        let allowRoles = [ROLE.SA.code];
                        if (role === ROLE.WA.code && child.id === 18100) {
                            allowRoles.push(ROLE.WA.code)
                        }
                        return (
                <Route key={child.id} element={<AuthorityRoute pageRole={allowRoles} />}> {/* 접근권한 체크 Route */}
                    <Route path={child.path + '/*'} element={ <MonitoringSettingTabsRoutes menuId={child.id}/> }/>
                </Route>
                        )
                    }) 
                }
                <Route path="*" element={ <Error404/> }/>
            </Route>
        </Routes>
    );
}